<template lang="pug" src="./welcome.pug"></template>

<script>
import Icon from 'components/icon/icon'
import { moveTo, showModal } from '@/mixins'

export default {
  data () {
    return {
      active: false
    }
  },
  computed: {
    props () {
      return this.$store.state.pages['welcome']
    }
  },
  mixins: [ moveTo, showModal ],
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// welcome.vue?1dc4f087